import { ApiBase } from "@/api/ApiBase";

export interface MesaResumo {
  id: number;
  codigo: string;
  nome: string;
  lugares: number;
  zona: string | null;
  estabelecimentoId: number;
  nomeEstabelecimento: string;
  numeroEstabelecimento: string;
  lugaresOcupados: number;
  totalReservasAbertas: number;
  /** null = mesa livre; "Total" = uma única reserva ocupa toda a mesa; "Parcial" = mesa não totalmente ocupada, ou ocupada por várias reservas. */
  ocupacaoTipo: "Total" | "Parcial" | null;
  estado: "Disponível" | "Ocupada";
}

export interface DadosMesaForm {
  nome: string;
  lugares: number;
  zona: string;
  estabelecimentoId: number;
}

export interface EditarApagarMesaResponse {
  msg: string;
  tipo: "sucesso" | "erro";
}

export interface HistoricoReservaMesaItem {
  id: number;
  codigo: string;
  estado: "Aberto" | "Fechado";
  motivoFecho: "Indefinido" | "Pago" | "Anulado";
  nomeCliente: string;
  nifCliente: string;
  nomeVendedor: string;
  dataCriacao: string;
  dataFecho: string | null;
}

export class MesasApi extends ApiBase {
  listar(): Promise<MesaResumo[]> {
    return this.http.put<MesaResumo[]>("/api-pos/mesa/lista-by-comerciante");
  }

  private construirDados(
    dados: DadosMesaForm,
    codigoExistente?: string,
  ): Record<string, string> {
    const params: Record<string, string> = {
      nome: dados.nome,
      lugares: String(dados.lugares),
      zona: dados.zona,
      "estabelecimento.id": String(dados.estabelecimentoId),
    };
    if (codigoExistente) params.codigo = codigoExistente;
    return params;
  }

  adicionar(dados: DadosMesaForm): Promise<EditarApagarMesaResponse> {
    return this.http.post<EditarApagarMesaResponse>(
      "/api-pos/mesa/add",
      this.construirDados(dados),
    );
  }

  editar(
    codigo: string,
    dados: DadosMesaForm,
  ): Promise<EditarApagarMesaResponse> {
    return this.http.post<EditarApagarMesaResponse>(
      "/api-pos/mesa/edit",
      this.construirDados(dados, codigo),
    );
  }

  apagar(codigo: string): Promise<EditarApagarMesaResponse> {
    return this.http.post<EditarApagarMesaResponse>("/api-pos/mesa/delete", {
      codigo,
    });
  }

  listaHistoricoReservas(
    codigo: string,
    pagina: number,
  ): Promise<HistoricoReservaMesaItem[]> {
    return this.http.put<HistoricoReservaMesaItem[]>(
      `/api-pos/reserva/lista-historico-by-mesa/${codigo}/${pagina}`,
    );
  }

  fecharReservaAdmin(idReserva: number): Promise<EditarApagarMesaResponse> {
    return this.http.post<EditarApagarMesaResponse>(
      `/api-pos/reserva/fechar-admin/${idReserva}`,
    );
  }
}
